import { useAccount } from '~publish/contexts/AccountContext'

import styles from './Banners.module.css'

/**
 * App-level host for account-scoped banners, mounted inside the page
 * container (`RootLayout.Main`). Renders an empty container until banners
 * mount here.
 *
 * The host bleeds to the page container's edges and gives each banner the
 * page's inline padding, so banner content aligns with page content.
 */
export function Banners(): JSX.Element | null {
  const { account } = useAccount()

  // Banner eligibility is account-driven; without an account there is
  // nothing to evaluate.
  if (!account) {
    return null
  }

  return <div className={styles.banners} data-testid="app-banners" />
}
